import 'babel-polyfill';

import React, { Component } from 'react';
import './css/App.css';
import './css/ep-filters.css';
import episodes from './json/episodes.json';
import moment from 'moment';
import { doublePad, shuffleArray } from './util';
import Episode from './Episode';
import Rating from './Rating';

export default class App extends Component {
  constructor(props) {
    super(props);

    let ratingSortedEpisodes =
      Array.from(episodes).sort((l, r) => {
        return l.rating < r.rating ? -1 : (l.rating > r.rating ? 1 : 0);
      });

    this.augmentedEpisodes =
      Array.from(episodes).map(ep => {
        let rankedIndex = ratingSortedEpisodes.findIndex(other => other.episode === ep.episode && other.season === ep.season);
        return Object.assign({}, ep, {
          normalRank: rankedIndex / (episodes.length - 1),
          key: (ep.season << 5) | ep.episode
        });
      });

    this.state = {
      filter: '',
      season: null,
      shuffled: true,
      episodes: shuffleArray(Array.from(this.augmentedEpisodes)),
      minRating: 1
    };

    this.handleFilter = this.handleFilter.bind(this);
  }
  handleFilter(event) {
    this.setState({ filter: event.target.value });
  }
  handleSeason(season, event) {
    this.setState({ season });
  }
  handleShuffle(options) {
    let newValue = options.shuffle !== undefined ? options.shuffle : !this.state.shuffled;

    if (newValue) {
      this.setState({
        episodes: shuffleArray(Array.from(this.augmentedEpisodes)),
        shuffled: true,
        season: null
      })
    } else {
      this.setState({
        episodes: this.augmentedEpisodes,
        shuffled: false
      })
    }
  }
  handleMinRating(stars) {
    this.setState({ minRating: stars });
  }
  render() {
    let filterParts = null;
    if (this.state.filter.trim()) {
      filterParts = this.state.filter.split(' ').map(p => p.toLowerCase());
    }

    let seasons = [...Array(episodes[episodes.length - 1].season).keys()];

    let pagination = null;

    if (!this.state.shuffled) {
      pagination = (
        <ul className="ep-filters">
          <li>
            <a href="#" onClick={this.handleSeason.bind(this, null)}>All</a>
          </li>
          {seasons.map(s => <li key={s}><a href="#" onClick={this.handleSeason.bind(this, s + 1)} className={s + 1 === this.state.season ? "active" : ""}>S{doublePad(s + 1)}</a></li>)}
        </ul>
      );
    }

    let minNormalRank = (this.state.minRating - 1.5) / 4;

    let filteredEpisodes =
      this.state.episodes
        .filter(ep => this.state.season === null || ep.season === this.state.season)
        .filter(ep => {
          if (filterParts != null) {
            let epNameLower = ep.name.toLowerCase();
            if (!filterParts.find(p => epNameLower.includes(p)))
              return false;
          }
          return ep.normalRank > minNormalRank;
        })

    let today = { date: moment().date(), month: moment().month() };

    let todayEpisodes =
      this.state.episodes.filter(ep => moment(ep.airDate).date() === today.date && moment(ep.airDate).month() === today.month)
        .map(ep => <Episode key={ep.key} data={ep} today={true} />)

    let episodeCount = null;
    if (filteredEpisodes.length !== this.state.episodes.length) {
      episodeCount = (
        <p className="ep-count">
          Showing {filteredEpisodes.length} of {this.state.episodes.length} episodes
        </p>
      );
    }

    return (
      <div className="app">
        <div>
          <input type="text" className="search-box" placeholder="Search episodes..." value={this.state.filter} onChange={this.handleFilter} />
        </div>

        <div className="button-panel">
          <button type="button" className="btn" onClick={this.handleShuffle.bind(this, { shuffle: true })}>
            <i className="fa fa-random" aria-hidden="true"></i> Shuffle {this.state.shuffled ? 'again' : ''}
          </button>

          {this.state.shuffled ? (<button type="button" className="btn" onClick={this.handleShuffle.bind(this, {})}>
            <i className="fa fa-sort-numeric-asc" aria-hidden="true"></i> Re-order
          </button>) : null}
        </div>

        {todayEpisodes}

        {pagination}

        <ul className="ep-filters">
          <li>At least:</li>
          {[1, 2, 3, 4, 5].map(stars => <li key={stars}><a href="#" onClick={this.handleMinRating.bind(this, stars)} className={this.state.minRating === stars ? 'active' : ''}><Rating rating={stars} /></a></li>)}
        </ul>

        {episodeCount}

        {filteredEpisodes
          .map(ep => <Episode key={ep.key} data={ep} filterParts={filterParts} />)
        }

        {filteredEpisodes.length === 0 ? <p>No results.</p> : null}

        {pagination}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js